import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { renderCmsModule } from '../../util/cms-module-renderer'

import Markdown from '../../components/atoms/Markdown/Markdown'
import Header from '../../components/molecules/Header/Header'

import {
  LandingPageContainer,
  LandingPageInnerContainer,
} from './LandingPage.css.js';

class LandingPage extends Component {
  constructor(props) {
    super(props);
  }

  renderPageSections(pageSections) {
    const renderModule = (_module) => (<>{_module.enabled && renderCmsModule(_module)}</>)

    const renderedPageSections = pageSections.map((pageSection, index) => {
      return (
        <span key={index}>
          {pageSection.pageHero && renderModule(pageSection.pageHero)}

          {pageSection.featuredPoster && renderModule(pageSection.featuredPoster)}

          {pageSection.eventPoster && renderModule(pageSection.eventPoster)}

          {pageSection.collageBanner && renderModule(pageSection.collageBanner)}

          {pageSection.quoteHero && renderModule(pageSection.quoteHero)}

          {pageSection.htmlSection && pageSection.htmlSection.enabled && (
            <LandingPageContainer>
              <LandingPageInnerContainer
                isCenteredSection={true}
                removeGutters={true}
              >
                {pageSection.htmlSection.html && <Markdown body={pageSection.htmlSection.html} />}
              </LandingPageInnerContainer>
            </LandingPageContainer>
          )}
        </span>
      )
    });

    return renderedPageSections;
  }

  render() {
    const {
      header,
      page,
    } = this.props.content;

    return (
      <div>
        <Header
          {...header}
        />

        {page.pageSections && this.renderPageSections(page.pageSections)}

        {page.pageHero && renderCmsModule(page.pageHero)}
      </div>
    );
  }
}

LandingPage.propTypes = {
  config: PropTypes.shape({
    hasHeader: PropTypes.bool.isRequired,
  }),
  content: PropTypes.shape({
    header: {
      config: PropTypes.shape({
        showLogo: PropTypes.bool,
      }),
      content: PropTypes.shape({
        navigationItems: PropTypes.shape({
          label: PropTypes.string.isRequired,
          link: PropTypes.string.isRequired,
        }).isRequired,
      }),
    },
    page: PropTypes.shape({
      title: PropTypes.string.isRequired,
      subtitle: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      featuredImage: PropTypes.string,
    }).isRequired,
  }),
};

LandingPage.defaultProps = {
  config: {
    hasHeader: true,
  },
};

export default LandingPage;